import qs from 'qs';

export const queryParamsJSON = (prev: URLSearchParams, object: Object) => {
    return qs.stringify({ ...qs.parse(prev.toString()), ...object }, { encode: false });
};
